import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import * as actions from '@actions';
import SiteFhqService from '@rootCommon/services/site-fhq-service';
import { SiteFhq } from '@rootTypes/fhq';
import { EntityStatus, IdType } from '@rootTypes/common';
import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchFhqsAsync(action: { payload: IdType }) {
  try {
    const fhqs: SiteFhq[] = yield call(SiteFhqService.getAdminSiteFhqs, action.payload);

    yield put(actions.fetchFhqs.success(fhqs));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqs.failure(error));
  }
}

function* watchFetchFhqs() {
  yield takeLatest(actions.fetchFhqs.request, fetchFhqsAsync);
}

// update
function* updateFhqsAsync(action: { payload: SiteFhq[] }) {
  try {
    yield all(
      action.payload.map((record) => (record.status === EntityStatus.UPDATE
        ? call(SiteFhqService.updateAdminSiteFhq, record.id, record)
        : record)),
    );
    yield put(actions.updateFhqs.success(action.payload));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqs.failure(error));
  }
}

function* watchUpdateFhqs() {
  yield takeLatest(actions.updateFhqs.request, updateFhqsAsync);
}

// all
function* watchFhqs(): SagaGenerator {
  yield all([watchFetchFhqs(), watchUpdateFhqs()]);
}

export default watchFhqs;
